import { ApplicationStage } from "../enums/CandidateStatus"
import { ScoringFailureReason, ScoringStatus } from "../enums/ScoringStatus"

export interface ApplicationDetails {
  id: string
  candidateId: string
  vacancyId: string
  organizationId: string
  matchScore: ScoreBreakdownDto
  currentStage: string
  appliedAt: string
  vacancyTitle: string
  candidate: CandidateForApplicationDetails
  interviews: InterviewDetails[]
  isIdVerificationCompleted: boolean
  scoringStatus?: ScoringStatus
  scoringFailureReason?: ScoringFailureReason
  lastScoringAttemptAt?: string | null
}
export interface SkillMatchDetail {
  skillName: string
  category: string
  matchPercentage: number
  normalizedWeight: number
  weightedContribution: number
  explanation: string
}

export interface TailoringExactPhraseMatch {
  phrase: string
  location: string
  context: string
}
export interface TailoringStructuralSimilarity {
  detected: boolean
  confidence: number
  notes: string
}
export interface TailoringSignals {
  exactPhraseMatches: TailoringExactPhraseMatch[]
  keywordOverlap: string[]
  structuralSimilarity: TailoringStructuralSimilarity
  tailoringIndicators: string[]
}

export interface ScoreBreakdownDto {
  score: number
  aiProbabilityScore?: number
  tailoringSignals?: TailoringSignals
  skillBreakdown: SkillMatchDetail[]
  scoredAt: string
  strengths: string[]
  weaknesses: string[]
}

export interface CandidateForApplicationDetails {
  id: string
  firstName: string
  lastName: string
  email: string
  phone: string
  cvUrl: string
  experienceYears: number
  education: string
  skills: string[]
  createdAt: string
  updatedAt: string
  applicationCount: number
  idNumber?: string | null
}

export interface InterviewDetails {
  id: string
  applicationId: string
  title?: string
  status: string
  type: string
  recordingUrl?: string
  transcript?: string
  aiSummary?: string
  interviewNotes?: string
  createdAt: string
  timeSlots: TimeSlot[]
}

export interface TimeSlot {
  id: string
  startTime: string
  endTime: string
  isSelected: boolean
}

export function parseApplicationStage(stage: string): ApplicationStage {
  switch (stage.toLowerCase()) {
    case "applied":
      return ApplicationStage.Applied
    case "screened":
      return ApplicationStage.Screened
    case "candidate":
      return ApplicationStage.Candidate
    case "hired":
      return ApplicationStage.Hired
    case "rejected":
      return ApplicationStage.Rejected
    default:
      return ApplicationStage.Applied // Default fallback
  }
}
